// Material Kit 2 React pages
import Club from "pages/Club";

export default function Clubs() {
  return <Club />;
}
